import { createBatchActionsModule } from 'redux/reusable/batchSelections';
import type { PaginationState } from 'redux/reusable/pagination';
import { createPaginationModule } from 'redux/reusable/pagination';
import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule } from 'redux/reusable/xhrStatus';
import type { EnrichedForecast, Forecast, ForecastDraft } from 'routes/forecast/types/forecast';
import { actionCreatorFactory } from 'typescript-fsa';

export const { batchSelectionActions, withBatchSelectionsReducer } =
  createBatchActionsModule<State['selection']>('forecast-selection');
export const forecastXhrModule = createXhrStatusModule('forecast');
export const { withPaginationReducer, paginationActions } =
  createPaginationModule('forecast-pagination');

const actionCreator = actionCreatorFactory('timely/forecast');

export const fetchedForecasts = actionCreator<Array<Forecast>>('FETCHED');
export const fetchedForecast = actionCreator<Forecast>('FETCHED_SINGLE');
export const clearAllForecasts = actionCreator('CLEAR_ALL');

export const setForecastDraft = actionCreator<ForecastDraft>('SET_DRAFT');
export const updateForecastDraft = actionCreator<Partial<ForecastDraft>>('UPDATE_DRAFT');
export const clearForecastDraft = actionCreator('CLEAR_DRAFT');

export const deleteForecastIds = actionCreator<Array<number>>('BULK_DELETE');
export const deleteForecastId = actionCreator<number | string>('DELETE');

export const clearQuery = actionCreator('CLEAR_QUERY');
export const setQuery_ = actionCreator<Partial<ForecastQuery>>('SET_QUERY');

export const setPopoverPrefInSession = actionCreator<boolean>('SET_POPOVER_PREF_IN_SESSION');

export const FORECAST_PAGE_LIMIT = 50;

export interface ForecastQuery {
  projectIds: Array<number>;
  userIds: Array<number | null> | null;
  teamIds: Array<number> | null;
  showCompleted: boolean;
  onlyShowProjectAssignees: boolean;
  since: string | null;
  until: string | null;
  dateSpan: 'day' | 'week' | 'month' | 'custom';
}

export interface State {
  draft: ForecastDraft | null;
  entities: Record<number | string, Forecast>;
  result: Array<number | string>;
  xhrStatus: XhrStatus;
  pagination: PaginationState;
  query: ForecastQuery;
  selection: { forecastIds: Array<number>; completedState: null | boolean };
  didSetPopoverPrefInSession: boolean;
}

export interface ForecastStorageStates {
  active: Array<EnrichedForecast>;
  upcoming: Array<EnrichedForecast>;
  completed: Array<EnrichedForecast>;
}

export type ForecastStorageKeys = keyof ForecastStorageStates;
